"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TrafficAppointmentCardStyles = require("../../styles/TrafficAppointmentCardStyles2");

var _WrapperBase = require("../../styles/base/WrapperBase");

var _TrafficBaseCard = _interopRequireDefault(require("./TrafficBaseCard2"));

var _reactDnd = require("react-dnd");

var _unusedIcon = _interopRequireDefault(require("./unusedIcon"));

var _ShipmentTicketDetailStyles = require("../../styles/ShipmentTicketDetailStyles");

var _moment = _interopRequireDefault(require("moment"));

require("moment/locale/es");

var _excluded = ["id", "icon", "description", "expClass", "onDrop", "dropOnWindow", "level", "color", "onClick", "free", "close", "dateValidation", "unused", "ununsedIcon", "content", "fontColor", "opIcon", "fleet_provider", "plates", "eta", "containers"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var dndTypes = {
  APPOINTMENT: 'appointment'
};

var TrafficAppointmentCard2 = function TrafficAppointmentCard2(_ref) {
  var id = _ref.id,
      icon = _ref.icon,
      description = _ref.description,
      expClass = _ref.expClass,
      onDrop = _ref.onDrop,
      dropOnWindow = _ref.dropOnWindow,
      level = _ref.level,
      color = _ref.color,
      onClick = _ref.onClick,
      free = _ref.free,
      close = _ref.close,
      dateValidation = _ref.dateValidation,
      unused = _ref.unused,
      ununsedIcon = _ref.ununsedIcon,
      content = _ref.content,
      fontColor = _ref.fontColor,
      opIcon = _ref.opIcon,
      fleet_provider = _ref.fleet_provider,
      plates = _ref.plates,
      eta = _ref.eta,
      containers = _ref.containers,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useDrag = (0, _reactDnd.useDrag)({
    item: {
      type: dndTypes.APPOINTMENT,
      orderId: id,
      spaceIndex: props.spaceIndex
    },
    collect: function collect(monitor) {
      return {
        isDragging: !!monitor.isDragging()
      };
    }
  }),
      _useDrag2 = _slicedToArray(_useDrag, 2),
      dragAppointment = _useDrag2[1];

  var _useDrop = (0, _reactDnd.useDrop)({
    accept: dndTypes.APPOINTMENT,
    drop: function drop(item) {
      return onDrop({
        begin: props.begin,
        spaceId: props.spaceId,
        spaceIndex: props.spaceIndex
      }, item);
    },
    collect: function collect(monitor) {
      return {
        isOverAppointment: !!monitor.isOver()
      };
    }
  }),
      _useDrop2 = _slicedToArray(_useDrop, 2),
      isOverAppointment = _useDrop2[0].isOverAppointment,
      dropAppointment = _useDrop2[1];

  var _useDrop3 = (0, _reactDnd.useDrop)({
    accept: dndTypes.APPOINTMENT,
    drop: function drop(item) {
      return dropOnWindow({
        begin: props.begin,
        spaceId: props.spaceId,
        spaceIndex: props.spaceIndex
      }, item);
    },
    collect: function collect(monitor) {
      return {
        isOverFree: !!monitor.isOver()
      };
    }
  }),
      _useDrop4 = _slicedToArray(_useDrop3, 2),
      isOverFree = _useDrop4[0].isOverFree,
      freeAppointment = _useDrop4[1];

  var unusedByDate = dateValidation < 0 ? true : dateValidation === 0 ? unused : false;

  var setContainersEta = function setContainersEta(containers, size_style) {
    var timesToShow = [];
    (containers || []).map(function (container) {
      var _container$ata, _container$eta;

      var ataDate = (_container$ata = container === null || container === void 0 ? void 0 : container.ata) !== null && _container$ata !== void 0 ? _container$ata : '';
      var etaDate = (_container$eta = container === null || container === void 0 ? void 0 : container.eta) !== null && _container$eta !== void 0 ? _container$eta : '';
      var appointment = container === null || container === void 0 ? void 0 : container.date;
      var timeToValidate = ataDate === '' ? etaDate : ataDate;
      var isEta = ataDate === '';

      if (timeToValidate === '') {
        timesToShow.push( /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETACardDescription, {
          style: {
            fontSize: size_style === 2 ? 6 : size_style === 3 ? 8 : 5
          }
        }, 'ETA: No disponible '));
      } else {
        var isRedColor = false;

        if (appointment !== '') {
          isRedColor = (0, _moment["default"])(timeToValidate).isSameOrAfter(appointment);
        }

        if (isRedColor) {
          timesToShow.push( /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETAWrapper, null, /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETACardDescription, {
            style: {
              fontSize: size_style === 2 ? 6 : size_style === 3 ? 8 : 5
            }
          }, isEta ? 'ETA: ' : 'ATA: '), /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETACardlate, {
            style: {
              fontSize: size_style === 2 ? 7 : size_style === 3 ? 8 : 6
            }
          }, "".concat((0, _moment["default"])(timeToValidate).format("DD MMMM HH:mm"), " hr"))));
        } else {
          timesToShow.push( /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETAWrapper, null, /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETACardDescription, {
            style: {
              color: 'black',
              fontSize: size_style === 2 ? 6 : size_style === 3 ? 8 : 5
            }
          }, isEta ? 'ETA: ' : 'ATA: '), /*#__PURE__*/_react["default"].createElement(_ShipmentTicketDetailStyles.ETACardlow, {
            style: {
              fontSize: size_style === 2 ? 7 : size_style === 3 ? 8 : 6
            }
          }, "".concat((0, _moment["default"])(timeToValidate).format("DD MMMM HH:mm"), " hr"))));
        }
      }
    });
    return /*#__PURE__*/_react["default"].createElement("div", null, timesToShow);
  };

  var size_style = 2;

  if (props.begin && props.end) {
    var difference = props.end - props.begin;

    if (difference < 110) {
      size_style = 1;
    } else if (difference > 199) {
      size_style = 3;
    }
  }

  return /*#__PURE__*/_react["default"].createElement(_TrafficBaseCard["default"], _extends({
    rf: unused ? undefined : free ? freeAppointment : close ? undefined : dropAppointment,
    isOverFree: isOverFree,
    free: free,
    unused: unusedByDate,
    close: close,
    color: color,
    onClick: onClick,
    id: 'card-'.concat(id),
    isAppointment: !free && !close
  }, props), (props.midLines || []).map(function (line) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        position: "absolute",
        height: "100%",
        borderLeft: "0.1rem #51afec dashed",
        left: line.pct + '%'
      }
    });
  }), !free && !close && !unused && /*#__PURE__*/_react["default"].createElement(_TrafficAppointmentCardStyles.Wrapper, _extends({}, props, {
    color: color,
    isOverAppointment: isOverAppointment,
    fontColor: fontColor,
    ref: dragAppointment
  }), /*#__PURE__*/_react["default"].createElement(_TrafficAppointmentCardStyles.DescriptionWrapper, {
    style: {
      fontSize: size_style === 2 ? 10 : size_style === 3 ? 13 : 7
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, description), expClass && /*#__PURE__*/_react["default"].createElement(_TrafficAppointmentCardStyles.ExpClassTitle, {
    style: {
      fontSize: size_style === 2 ? 8 : size_style === 3 ? 10 : 6
    }
  }, expClass), /*#__PURE__*/_react["default"].createElement("div", null, level || "-")), /*#__PURE__*/_react["default"].createElement(_TrafficAppointmentCardStyles.ContentWrapper, {
    style: {
      fontSize: size_style === 2 ? 10 : size_style === 3 ? 13 : 7
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, fleet_provider), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, icon, " ", plates && /*#__PURE__*/_react["default"].createElement(_TrafficAppointmentCardStyles.PlatesWrapper, {
    style: {
      fontSize: size_style === 2 ? 9 : size_style === 3 ? 11 : 7
    }
  }, plates))), /*#__PURE__*/_react["default"].createElement(_TrafficAppointmentCardStyles.OtherDataWrapper, {
    hasExpClass: expClass,
    expClass: expClass
  }), setContainersEta(containers || [], size_style)), unusedByDate && /*#__PURE__*/_react["default"].createElement(_WrapperBase.WrapperBase, {
    row: true,
    justifyCenter: true,
    alignCenter: true
  }));
};

TrafficAppointmentCard2.propTypes = {
  id: _propTypes["default"].number,
  free: _propTypes["default"].bool,
  close: _propTypes["default"].bool,
  icon: _propTypes["default"].any,
  content: _propTypes["default"].any,
  ununsedIcon: _propTypes["default"].any,
  description: _propTypes["default"].string,
  expClass: _propTypes["default"].string,
  level: _propTypes["default"].number,
  className: _propTypes["default"].string,
  color: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  fontColor: _propTypes["default"].string,
  unused: _propTypes["default"].bool
};
TrafficAppointmentCard2.defaultProps = {
  id: null,
  free: false,
  close: false,
  icon: null,
  description: null,
  expClass: null,
  level: null,
  content: null,
  className: null,
  color: null,
  onClick: function onClick() {},
  unused: false,
  fontColor: '#ffffff',
  ununsedIcon: /*#__PURE__*/_react["default"].createElement(_unusedIcon["default"], {
    width: "20px",
    fill: "white"
  })
};
var _default = TrafficAppointmentCard2;
exports["default"] = _default;